import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, HelperService, Product, ProductService, ProductSnapshot, UserService } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-beta-details",
  templateUrl: "beta-details.component.html",
  standalone: false,
})
export class BetaDetailsComponent extends BaseComponent implements OnInit {
  @Input() betaProgram: any;
  public redeemingProduct: boolean = false;
  public loading: boolean;
  public productDetails: any = {};
  public isBetaManager: boolean;
  constructor(
    userService: UserService,
    public productService: ProductService,
    public helperService: HelperService
  ) {
    super(userService);
    this.isBetaManager = this.user?.groups?.length ? this.user.groups.some((group: any) => group.name === "beta_manager") : false;
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    if (this.betaProgram && this.betaProgram.products) {
      const firstProduct = this.betaProgram.products[0];
      if (firstProduct && firstProduct.id) {
        this.getProductDetails(firstProduct);
      }
    }
  }

  getProductDetails(product) {
    if (!this.productDetails[product.id]) {
      product.loading = true;
      this.productService.getProductSnapshot(product.id, undefined, this.betaProgram.id).subscribe((snapshot: ProductSnapshot) => {
        product.expanded = true;
        this.productDetails[snapshot.product.id] = snapshot;
        product.loading = false;
      });
    } else {
      product.expanded = !product.expanded;
    }
  }

  claimBetaProduct(claimBetaProduct) {
    this.redeemingProduct = true;
    this.productService.redeemBetaProduct(this.betaProgram.id).subscribe((result) => {
      this.productService.getProducts(true).subscribe((result) => {
        this.redeemingProduct = false;
      });
    });
  }
}
